module.exports = __webpack_public_path__ + "static/media/newest.e0320733.png";